import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { Tender } from 'src/app/models/Tender.class';
import { SelectTenderEventProps } from 'src/app/models/SelectTenderEventProps.class';
import { trigger, style, animate, transition } from '@angular/animations';
import { ShareDataServiceService } from 'src/app/services/share-data-service.service';
import { File as LocalFile } from 'src/app/models/File.class';

@Component({
  selector: 'app-tender',
  templateUrl: './tender.component.html',
  styleUrls: ['./tender.component.css'],
  animations: [
    trigger(
      'enterAnimation', [
        transition(':enter', [
          style({transform: 'translateY(-5%)', opacity: 0}),
          animate('300ms', style({transform: 'translateY(0)', opacity: 1}))
        ]),
        transition(':leave', [
          style({transform: 'translateY(0)', opacity: 1}),
          animate('300ms', style({transform: 'translateY(-5%)', opacity: 0}))
        ])
      ]
    )
  ]
})
export class TenderComponent implements OnInit {

  getFromNavigaionState(key:string):any{
    const nav = this.router.getCurrentNavigation() || (this.router as any).lastSuccessfulNavigation;;
    if(!nav || !nav.extras || !nav.extras.state || !nav.extras.state[key])
      return null;
    else
      return nav.extras.state[key];
  }

  constructor(private http: HttpClient, private route:ActivatedRoute, private router: Router,private shareDataService:ShareDataServiceService, private location:Location) {
  }
  
  //@Input() tenderId:number=-1;
  singlePage:boolean = false;
  showMore:boolean = false;
  showLinks:boolean = true;
  expandInMobile:boolean = false;
  registrationFormAddress:string ='';
  expiredTenderPaymentUrl:string = 'https://ecom.pay.gov.il/counter?serviceCode=105&catalogCode=2&categoryCode=MolsaTenders&page=home';
  loading:boolean = false;
  loadingFailed:boolean = false;

  @Input() tender:Tender = new Tender();
  @Output() onSelectTender:EventEmitter<SelectTenderEventProps> = new EventEmitter<SelectTenderEventProps>();
  @Output() onClose:EventEmitter<any> = new EventEmitter<any>();
  filesByType:any[]=[];

  ngOnInit(): void {
    if(this.tender.TenderId==null){
      this.singlePage = true;
      this.expandInMobile = window.innerWidth<500;
      const stateTender = this.getFromNavigaionState('tender');
      if(stateTender) {
        this.tender = stateTender;
        this.onLoadTender();
      }
      else{
        const id:string = (this.route.queryParams as any).value.id?(this.route.queryParams as any).value.id:window.location.href.substring(window.location.href.indexOf('/tender/')+'/tender/'.length);
        this.loading = true;
        this.shareDataService.get({url:environment.serviceUrl+'/api/tenders/'+id,method:'get'},'tender_'+id)
        .then((res:any)=> {
          this.tender = res;
          this.onLoadTender();
          this.loading = false;
        },err=>{
          console.log(err);
          this.loadingFailed = true;
          this.loading = false;
        });
      }
    }
    else{
      this.onLoadTender();
    }
  }

  onLoadTender():void{
      this.tender.Files.forEach((f:any)=>{
        f.FileLink= environment.serviceUrl+'/api/file/'+f.FileId;
      });
      this.tender.Files.forEach((f:any)=>{
        const i:number =this.filesByType.findIndex((ft:any)=>ft.TenderFileTypeId==f.TenderFileType.TenderFileTypeId); 
        if(i==-1)
          this.filesByType.push({TenderFileTypeId:f.TenderFileType.TenderFileTypeId,TenderFileTypeDesc:f.TenderFileType.TenderFileTypeDesc,Files:[f]});
        else
          this.filesByType[i].Files.push(f);
      });
      this.showLinks = this.calcShowLinks();
      this.registrationFormAddress = this.calcRegistrationFormUrl();
      
      if(this.singlePage) setTimeout(function(){window.scroll({top: 0,left: 0,behavior: 'smooth'});},1000);
  }

  getDdMmYyyy(jsonDate:string|undefined):string{
    if(!jsonDate)
      return '';
    const split:string[] = jsonDate.split('T')[0].split('-');
    if(split[0]=='0001') return '';
    return split[2]+'/'+split[1]+'/'+split[0];
  }

  gethhmm(jsonDate:string|undefined):string{
    if(!jsonDate)
      return '';
    const split:string[] = jsonDate.split('T');
    const splitDate:string[] = split[0].split('-');
    if(splitDate[0]=='0001') return '';
    const splitTime:string[] = split.length>1?split[1].split(':'):[];
    return splitTime.length>1?(' '+splitTime[0]+':'+splitTime[1]):'';
  }

  downloadFile(f:any){
    this.http.get(environment.serviceUrl+'/api/file/'+f.FileId)
    .subscribe((res:any)=> {
      console.log(res);
    },err=>{
      console.log(err);
    });
  }

  pay():void{
    if(!confirm('הנכם מועברים לביצוע התשלום מקוון באתר שרות התשלומים הממשלתי. ניתן לחזור בכל שלב לאתר משרד הרווחה באמצעות הקישור בשורת הניווט')) 
      return;
    var frmPayment = document.createElement("form");
    frmPayment.setAttribute("name","_payform");
    frmPayment.setAttribute("action", environment.govPaynetUrl);
    frmPayment.setAttribute("method", "post");
    var inputHiddenValue = document.createElement("input");
    inputHiddenValue.setAttribute("name","enc_string");
    inputHiddenValue.setAttribute("id","enc_string");
    inputHiddenValue.setAttribute("type", "hidden");
    inputHiddenValue.setAttribute("value", (this.tender.MolsaTenderEncryptedPayment!));
    frmPayment.appendChild(inputHiddenValue);
    var submitPaymentBtn = document.createElement("input");
    submitPaymentBtn.setAttribute("type", "submit");
    submitPaymentBtn.setAttribute("value", "");
    frmPayment.appendChild(submitPaymentBtn);
    document.body.appendChild(frmPayment);
    frmPayment.submit();
    if (frmPayment.parentNode){
      frmPayment.parentNode.removeChild(frmPayment);
    }
  }

  dateNotExpired(jsonDate:string|undefined):boolean{
    if(!jsonDate)
      return false;
    const split:number[] = jsonDate.split('T')[0].split('-').map(s=>parseInt(s));
    const now = new Date();
    if(now.getFullYear()<split[0] || (now.getFullYear()==split[0] && (now.getMonth()+1)<split[1]) || (now.getFullYear()==split[0] && (now.getMonth()+1)==split[1] && now.getDate()<=split[2]))
      return true;
    return false;
  }

  expandTender($event:any):void{
    if(window.innerWidth>500){
      this.showMore=!this.showMore;
      //$event.srcElement.closest('.one-res').setAttribute('aria-expanded',this.showMore);
      //$event.srcElement.closest('.show-more').style.display = this.showMore?'block':'none';
    }
    else
      //this.router.navigate(['../tender',{id:this.tender.TenderId}]);
      this.onSelectTender.emit({SelectedTender:this.tender,EventType:'expandTender'});
  }

  calcRegistrationFormUrl():string{
    const max:number = 90;
    const tenderTitle:string = this.tender.Title!.length>max?(this.tender.Title!.substring(0,max-3)+'...'):this.tender.Title!;
    const url = environment.registrationFormUrl
    .replace('{{TenderId}}',this.tender.TenderId!.toString())
    .replace('{{TenderNumber}}',this.tender.MolsaTenderNumber!)
    .replace('{{TenderTitle}}',tenderTitle);
    return url;
  }

  openRegistration():void{
    const url = this.calcRegistrationFormUrl();
    window.open(url);
    //this.router.navigateByUrl('/tenders/registration/'+this.tender.TenderId,{state: {tender:this.tender}});
  }

  openQuestions():void{
    this.router.navigateByUrl('/questions/'+this.tender.TenderId,{state: {tender:this.tender}});
  }

  backToTenders():void{
    //this.location.back();
    this.router.navigate(['']);
    setTimeout(function(){
      (document.querySelector('h1') as any).focus();
    },1000);
  }

  close():void{
    this.onClose.emit();
  }

  calcShowLinks():boolean{
    if(this.tender.MolsaTenderInManof || 
      this.dateNotExpired(this.tender.MolsaProposalHandingDate) || 
      (this.tender.MolsaTenderQADate && this.dateNotExpired(this.tender.MolsaTenderQADate)) || 
      (this.tender.MolsaTenderPayment && this.tender.MolsaTenderPayment>0 && this.dateNotExpired(this.tender.MolsaProposalHandingDate)) ||
      this.showExpiredProposalHanding()
    )
      return true;
    return false;
  }

  showExpiredProposalHanding():boolean{
    return !!this.tender.MolsaProposalHandingDate && !this.dateNotExpired(this.tender.MolsaProposalHandingDate);
  }

  getManofLink():string{
    const orgHTML:string = this.tender.MolsaTenderInManof!;
    const startHref:number = orgHTML.indexOf('>');
    const endHref:number = orgHTML.indexOf('</a');  
    if(startHref==-1 || endHref<startHref)
      return '';
    const href:string =  orgHTML.substring(startHref+1,endHref);
    return '<a target="_blank" href="'+href+'">קישור למנו"ף</a>';
  }

  getFileType(f:LocalFile):string{
    const ext:string = f.FileName && f.FileName.indexOf('.')>-1 && f.FileName.indexOf('.')<(f.FileName.length-1)?f.FileName.substring(f.FileName.lastIndexOf('.')+1):'';
    switch(ext)
    {
      case 'doc': 
      case 'docx':
        return 'WORD';
    }
    return ext;
  }

  getFileLabel(f:LocalFile):string{
    if(!f.FileName) return '';

    const dotI:number = f.FileName.lastIndexOf('.');
    if(dotI==-1 || dotI==(f.FileName.length-1)) return '';

    const fileName:string = f.FileName.substring(0,dotI);
    let ext:string = f.FileName.substring(dotI+1);
    switch(ext)
    {
      case 'doc': 
      case 'docx':
        ext = 'WORD';
    }
    return fileName+'  - יורד כקובץ '+ ext;
  }
}
